import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useMaintenanceMode } from '../../hooks/useMaintenanceMode';

export default function MaintenancePage() {
  const { config, loading } = useMaintenanceMode();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-brand-cream">
        <i className="ri-loader-4-line animate-spin text-3xl text-brand-gray-400" />
      </div>
    );
  }

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 overflow-hidden bg-brand-cream">
      {/* Decorative background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-[600px] h-[600px] rounded-full bg-brand-sage/8 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] rounded-full bg-brand-gray-100/40 blur-2xl" />
      </div>

      {/* Large watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
        <span className="text-[12rem] md:text-[18rem] font-black text-brand-gray-200/40 tracking-tighter">
          AS
        </span>
      </div>

      <div className="relative z-10 max-w-lg w-full">
        {/* Icon */}
        <div className="w-20 h-20 rounded-full bg-brand-black flex items-center justify-center text-white mx-auto">
          <i className="ri-tools-line text-3xl" />
        </div>

        <h1 className="font-serif text-brand-black text-3xl md:text-4xl font-medium mt-8 leading-tight">
          En mantenimiento
        </h1>

        <p className="font-sans text-brand-gray-600 text-base md:text-lg mt-4 leading-relaxed max-w-md mx-auto">
          {config.message}
        </p>

        {config.eta && (
          <p className="font-sans text-brand-gray-400 text-sm mt-3 italic">
            {config.eta}
          </p>
        )}

        {config.showAdminLink && (
          <div className="mt-10">
            <Link
              to="/admin"
              className="inline-flex items-center gap-2 bg-brand-black text-white font-sans text-sm tracking-widest uppercase px-8 py-3.5 rounded-full hover:bg-brand-gray-800 transition-colors whitespace-nowrap"
            >
              <i className="ri-shield-user-line" />
              Acceso administrador
            </Link>
          </div>
        )}

        {/* Contact mini */}
        <div className="mt-12 pt-8 border-t border-brand-gray-200">
          <p className="font-sans text-brand-gray-400 text-xs uppercase tracking-[0.2em] mb-3">
            Atelier Anthony Sánchez Couture
          </p>
          <a
            href="mailto:anthosanchez3108@gmail.com"
            className="font-sans text-brand-gray-500 text-sm hover:text-brand-black transition-colors"
          >
            anthosanchez3108@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
}